<template>
  <div>
    <div class="card">
      <div class="card-header">
        <router-link to="/auctions/create" v-if="isSuperUser">
          <a-button type="primary" style="margin-bottom: 10px"
            ><i
              class="fe fe-shopping-bag font-size-15"
              title="Schedule new auction"
              style="margin-right: 10px"
            />
            Schedule new auction
          </a-button>
        </router-link>
      </div>

      <div class="card-body">
        <div style="margin-bottom: 16px">
          <a-input-search
            v-model="searchText"
            placeholder="Search auctions..."
            style="width: 300px"
            @search="onSearch"
            @pressEnter="onSearch"
            allowClear
          />
        </div>
        <a-spin :spinning="working">
          <a-table
            :columns="columns"
            :dataSource="auctions"
            :pagination="pagination"
            :loading="working"
            @change="handleTableChange"
          >
            <template slot="type" slot-scope="text">
              <a class="btn btn-sm btn-light" href="javascript: void(0);">{{
                text
              }}</a>
            </template>
            <template slot="name" slot-scope="text">
              <a class="btn btn-sm btn-light" href="javascript: void(0);">{{
                text
              }}</a>
            </template>

            <router-link
              :to="'/auctions/' + record.id + '/live'"
              slot="id"
              slot-scope="text, record"
            >
              <a href="javascript: void(0);" class="btn btn-sm btn-light">{{
                text
              }}</a>
            </router-link>

            <span slot="shipping" slot-scope="text">${{ text }}</span>
            <span
              slot="status"
              slot-scope="text"
              :class="statusClasses(text)"
              >{{ text }}</span
            >

            <span slot="startsAt" slot-scope="text">{{
              moment(text).format('DD.MM.YYYY HH:mm')
            }}</span>
            <span slot="endsAt" slot-scope="text">{{
              moment(text).format('DD.MM.YYYY HH:mm')
            }}</span>

            <span slot="action" slot-scope="record">
              <a-space :space="16">
                <router-link :to="'/auctions/' + record.id + '/live'">
                  <a-button type="primary" size="small"
                    ><i class="fe fe-arrow-up-right mr-2" />
                    Open
                  </a-button>
                </router-link>

                <a
                  class="text-danger"
                  v-if="record.status != 'live' && isSuperUser"
                  @click="() => deleteAuction(record.id)"
                  ><i class="fe fe-trash mr-2"
                /></a>
              </a-space>
            </span>
          </a-table>
        </a-spin>
      </div>
    </div>
  </div>
</template>
<script>
import { AuctionService } from '@/services/api'
import Vue from 'vue'
import moment from 'moment'
import { mapGetters } from 'vuex'

import { Space, Modal } from 'ant-design-vue'

Vue.use(Space)
Vue.use(Modal)

Vue.prototype.$confirm = Modal.confirm

const columns = [
  {
    title: 'ID',
    dataIndex: 'id',
    scopedSlots: { customRender: 'id' },
    sorter: true,
    defaultSortOrder: 'descend',
  },
  {
    title: 'Type',
    dataIndex: 'type',
    sorter: true,
    scopedSlots: {
      customRender: 'type',
    },
  },
  {
    title: 'Auction name',
    dataIndex: 'name',
    sorter: true,
    scopedSlots: {
      customRender: 'name',
    },
  },
  {
    title: 'Start date',
    dataIndex: 'startsAt',
    sorter: true,
    scopedSlots: {
      customRender: 'startsAt',
    },
  },
  {
    title: 'End date',
    dataIndex: 'endsAt',
    sorter: true,
    scopedSlots: {
      customRender: 'endsAt',
    },
  },
  {
    title: 'Status',
    dataIndex: 'status',
    sorter: true,
    scopedSlots: {
      customRender: 'status',
    },
  },
  {
    title: 'Actions',
    scopedSlots: { customRender: 'action' },
  },
]

export default {
  name: 'Auctions',
  data: function () {
    return {
      auctions: [],
      searchText: '',
      columns,
      working: false,
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        showSizeChanger: true,
        showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
        pageSizeOptions: ['10', '20', '50', '100'],
      },
      sortBy: 'id',
      sortOrder: 'desc',
    }
  },
  methods: {
    moment,
    createNewAuction() {},
    statusClasses(text) {
      return {
        'font-size-12': true,
        badge: true,
        'badge-primary': text == 'live',
        'badge-success': text == 'completed',
        'badge-default': text == 'announced',
        'badge-default': text == 'closed',
        'badge-danger': text == 'canceled',
      }
    },
    deleteAuction(auctionId) {
      let notification = this.$notification
      let fetchAuctions = this.fetchAuctions
      let that = this

      this.$confirm({
        title: 'Are you sure you want to delete this auction?',
        okText: 'Delete',
        okType: 'danger',
        cancelText: 'Cancel',
        onOk() {
          that.working = true
          AuctionService.delete(auctionId)
            .then((response) => {
              if (response.data.data) {
                notification['success']({
                  message: 'Auction deleted',
                  description: 'Auction has been deleted successfully.',
                })
              }
            })
            .catch((error) => {
              console.error(error)
              notification['error']({
                message: 'Auction could not be deleted.',
                description: error.error,
              })
            })
            .finally(() => {
              fetchAuctions()
            })
        },
        onCancel() {},
      })
    },
    onSearch() {
      this.pagination.current = 1
      this.fetchAuctions()
    },
    handleTableChange(pagination, filters, sorter) {
      this.pagination.current = pagination.current
      this.pagination.pageSize = pagination.pageSize

      if (sorter && sorter.field) {
        this.sortBy = sorter.field
        this.sortOrder = sorter.order === 'ascend' ? 'asc' : 'desc'
      } else {
        this.sortBy = 'id'
        this.sortOrder = 'desc'
      }

      this.fetchAuctions()
    },
    fetchAuctions() {
      this.working = true
      const params = {
        page: this.pagination.current,
        per_page: this.pagination.pageSize,
        sort_by: this.sortBy,
        sort_order: this.sortOrder,
      }

      if (this.searchText) {
        params.search = this.searchText
      }

      AuctionService.list(params)
        .then((response) => {
          this.auctions = response.data.data.map((row) =>
            Object.assign({ key: row.id }, row)
          )
          this.pagination.total = response.data.meta.total
          this.pagination.current = response.data.meta.current_page
          this.pagination.pageSize = response.data.meta.per_page
        })
        .catch((error) => {
          console.error(error)
        })
        .finally(() => {
          this.working = false
        })
    },
  },
  computed: {
    ...mapGetters('user', ['user']),
    isSuperUser() {
      return ['admin', 'operator'].includes(this.user.role)
    },
  },
  mounted() {
    this.fetchAuctions()
  },
}
</script>
<style scoped>
.custom-filter-dropdown {
  padding: 8px;
  border-radius: 4px;
  background: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.highlight {
  background-color: rgb(255, 192, 105);
  padding: 0px;
}
</style>
